import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ConnectAccountToSpruceInput,
  ConnectAccountToSpruceMutation,
  DisconnectAccountFromSpruceMutation,
} from '../../../gql/graphql';

const CONNECT_ACCOUNT_TO_SPRUCE = graphql(`
  mutation ConnectAccountToSpruce($input: ConnectAccountToSpruceInput!) {
    connectAccountToSpruce(input: $input) {
      __typename
      ... on ConnectAccountToSpruceSuccess {
        id
      }
      ... on ConnectAccountToSpruceInvalidAPIKey {
        message
      }
      ... on ConnectAccountToSpruceError {
        message
      }
    }
  }
`);

export const useConnectAccountToSpruce = (
  options?: UseMutationOptions<
    ConnectAccountToSpruceMutation,
    unknown,
    ConnectAccountToSpruceInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CONNECT_ACCOUNT_TO_SPRUCE, {
        input,
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};

const DISCONNECT_ACCOUNT_FROM_SPRUCE = graphql(`
  mutation DisconnectAccountFromSpruce {
    disconnectAccountFromSpruce
  }
`);

export const useDisconnectAccountFromSpruce = (
  options?: UseMutationOptions<
    DisconnectAccountFromSpruceMutation,
    unknown,
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return gqlClient.request(DISCONNECT_ACCOUNT_FROM_SPRUCE);
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};
